import React, { useState } from 'react';
import api from '../services/api';
import { readUser } from '../services/session';

type Job = {id: string; stage: string};
export default function GovJobLost({job, onSaved}: {job: Job; onSaved: () => void}) {
  const user = readUser();
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const lost = job.stage === 'lost';
  if (lost || !['admin','contracting_officer'].includes(user?.role || '')) return null;
  const save = async () => {
    setBusy(true); setError('');
    try {
      await api.post(`/gov/solicitations/${job.id}/advance`, {to_stage: 'lost', lost_reason: reason.trim(), expected_stage: job.stage});
      setOpen(false); setReason(''); onSaved();
    } catch (e: any) { setError(e.response?.data?.error || 'Unable to update this job.'); }
    finally {setBusy(false);}
  };
  const button: React.CSSProperties = {width:'100%',padding:12,borderRadius:10,border:'1px solid #2D4259',background:'#243447',color:'#EF4444',fontWeight:700,cursor:'pointer'};
  return <div style={{marginTop:12}}>
    <button style={button} onClick={() => {setError('');setOpen(true);}}>Job Lost</button>
    {open && <div role="dialog" aria-modal="true" aria-label="Job Lost" style={{position:'fixed',inset:0,zIndex:1100,background:'#0009',display:'flex',alignItems:'center',justifyContent:'center',padding:20}}>
      <div style={{background:'#1A2B3C',border:'1px solid #2D4259',borderRadius:16,padding:24,width:440,maxWidth:'100%'}}>
        <h2 style={{color:'#fff',marginTop:0}}>Job Lost</h2>
        <p style={{color:'#8FA8C0',lineHeight:1.5}}>Move this solicitation to Lost and keep its details, documents, notes, and activity history.</p>
        {<label style={{color:'#8FA8C0',fontSize:13,fontWeight:700}}>REASON<textarea aria-label="Lost reason" value={reason} maxLength={2000} onChange={e=>setReason(e.target.value)} placeholder="For example: Awarded to another contractor" style={{display:'block',boxSizing:'border-box',width:'100%',minHeight:100,marginTop:8,padding:12,borderRadius:10,border:'1px solid #2D4259',background:'#243447',color:'#fff'}} /></label>}
        {error && <p role="alert" style={{color:'#EF4444'}}>{error}</p>}
        <div style={{display:'flex',gap:12,marginTop:20}}>
          <button style={button} disabled={busy} onClick={()=>setOpen(false)}>Cancel</button>
          <button style={{...button,background:'#4A7EB5',color:'#fff'}} disabled={busy || !reason.trim()} onClick={save}>{busy?'Saving…':'Move to Lost'}</button>
        </div>
      </div>
    </div>}
  </div>;
}
